import React from "react";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer
      className="relative border-t border-white/5 bg-[#060A14] py-10 px-5 sm:px-8 lg:px-12"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <Logo size="md" />
        <div className="text-xs text-white/40">
          © {new Date().getFullYear()} Axe Marketing Services. Activations that cut through.
        </div>
      </div>
    </footer>
  );
}
